import React, { useEffect } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from 'layouts/auth-layout';
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH,PASS_PREFIX_PATH } from 'configs/AppConfig'
import useBodyClass from 'hooks/useBodyClass';
import jwtDecode from 'jwt-decode';
import {signOutAction, tokenRefreshedAction} from 'redux/actions/servicio-autenticacion/Auth';
import { REFRESH_TOKEN } from 'redux/constants/servicio-autenticacion/Auth';
import { refreshAccessToken } from 'auth/TokenRefresh';

function RouteInterceptor({ children, isAuthenticated, isTokenExpired, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated && !isTokenExpired ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}



export const Views = (props) => {
  const { locale, token, location, direction, signOutAction, tokenRefreshedAction } = props;
  const currentAppLocale = AppLocale[locale];

  // Cuando un interceptor renueva el token en segundo plano, actualizar redux
  useEffect(() => {
    const onTokenRefreshed = (event) => {
      const newToken = event?.detail?.token;
      if (newToken) {
        tokenRefreshedAction(newToken);
      }
    };
    window.addEventListener('auth:token-refreshed', onTokenRefreshed);
    return () => window.removeEventListener('auth:token-refreshed', onTokenRefreshed);
  }, [tokenRefreshedAction]);

  const isTokenExpired = () => {
    const currenTimeStamp = Math.floor(Date.now() / 1000);
        if(!token) {
          return false;
        }
        const { exp } = jwtDecode(token)
      if (currenTimeStamp >= exp) {
        // Si hay refresh token, intentar renovar la sesion en segundo plano
        // en lugar de cerrar la sesion de inmediato
        if (localStorage.getItem(REFRESH_TOKEN)) {
          refreshAccessToken().then((newToken) => {
            if (!newToken) {
              signOutAction();
            }
          });
          return false;
        }
        signOutAction();
        return true;

  } else {
    return false;
  }
  }
  
 
  useBodyClass(`dir-${direction}`);
  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}>
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route exact path="/">
            <Redirect to={APP_PREFIX_PATH} />
          </Route>
          <Route exact path="/">
            <Redirect to={PASS_PREFIX_PATH} />
          </Route>
          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </Route>
          <RouteInterceptor path={APP_PREFIX_PATH} isAuthenticated={token} isTokenExpired={isTokenExpired()}>
            <AppLayout direction={direction} location={location}/>
          </RouteInterceptor>
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  )
}


const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } =  theme;
  const { token } = auth;

  return { locale, direction, token }
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOutAction: () => dispatch(signOutAction()),
    tokenRefreshedAction: (token) => dispatch(tokenRefreshedAction(token)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Views));